import { useEffect, useState } from "react";
import { EButtonIcons } from "../../../../../local-interfaces/local-enum";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import FastRewindIcon from "@mui/icons-material/FastRewind";
import FastForwardIcon from "@mui/icons-material/FastForward";
import LightbulbIcon from "@mui/icons-material/Lightbulb";
import VolumeOffIcon from "@mui/icons-material/VolumeOff";
import PauseIcon from "@mui/icons-material/Pause";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import RepeatIcon from "@mui/icons-material/Repeat";
import StopIcon from "@mui/icons-material/Stop";
import DangerousIcon from "@mui/icons-material/Dangerous";
import { MdMediaBluetoothOn } from "react-icons/md";
import { GiUsbKey } from "react-icons/gi";
import RadioIcon from '@mui/icons-material/Radio';
import StreamIcon from '@mui/icons-material/Stream';;


function ComponentIcon(props: any) {
  const [compIcon, setCompIcon] = useState<string>();
  const [fontSize, setFontSize] = useState<number>();
  useEffect(() => {
    if (!props.comp) {
      return;
    }
    setCompIcon(props.comp?.icon);
    const tempFont = Math.min(props.comp.width, props.comp.height) * 50;
    setFontSize(tempFont);
  }, [props.comp]);

  switch (compIcon) {
    case EButtonIcons.play:
      return <PlayArrowIcon style={{ fontSize: fontSize }} />;

    case EButtonIcons.stop:
      return <StopIcon style={{ fontSize: fontSize }} />;

    case EButtonIcons.pause:
      return <PauseIcon style={{ fontSize: fontSize }} />;

    case EButtonIcons.backward:
      return <FastRewindIcon style={{ fontSize: fontSize }} />;

    case EButtonIcons.mute:
      return <VolumeOffIcon style={{ fontSize: fontSize }} />;

    case EButtonIcons.forward:
      return <FastForwardIcon style={{ fontSize: fontSize }} />;

    case EButtonIcons.light:
      return <LightbulbIcon style={{ fontSize: fontSize }} />;

    case EButtonIcons.reboot:
      return <PowerSettingsNewIcon style={{ fontSize: fontSize }} />;

    case EButtonIcons.repeat:
      return <RepeatIcon style={{ fontSize: fontSize }} />;

    case EButtonIcons.bluetooth:
      return <MdMediaBluetoothOn style={{ fontSize: fontSize }} />;

    case EButtonIcons.usb:
      return <GiUsbKey style={{ fontSize: fontSize }} />;
    case EButtonIcons.radio:
      return <RadioIcon style={{ fontSize: fontSize }} />
    case EButtonIcons.stream:
      return <StreamIcon style={{ fontSize: fontSize }} />

    default:
      return <DangerousIcon style={{ fontSize: fontSize }} />;
  }
}

export default ComponentIcon;
